
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 54 74","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('ellipse',{attrs:{"opacity":".3","cx":"27.339","cy":"33.704","rx":"15.234","ry":"15.995","fill":"var(--v-secondary-base)"}}),_c('path',{attrs:{"d":"M44.573 3.376L21.25 1.547a8 8 0 00-8.447 6.295L1.838 58.874c-.974 4.537 2.104 8.95 6.699 9.601l24.34 3.452a8 8 0 008.984-6.436l9.947-52.654c.884-4.678-2.49-9.088-7.236-9.46z","stroke":"#616161","stroke-width":"2.2","stroke-linecap":"round"}}),_c('path',{attrs:{"d":"M34.192 37.81l-1.069-.863a2.202 2.202 0 00-2.7-.052c-.819.61-1.98.61-2.703-.114a8.873 8.873 0 01-1.339-1.701c-.566-.937-1.2-2.595-1.502-3.755-.197-.761.283-1.361 1.03-1.607a2.654 2.654 0 001.8-2.89l-.128-.91c-.22-1.562-1.393-2.865-2.97-2.926-.785-.03-1.583.018-2.13.25-2.891 1.356-4.775 6.19-1.754 13.007 2.709 6.11 7.774 8.185 11.756 7.329 1.86-.4 2.594-1.809 2.88-2.978.26-1.068-.316-2.1-1.17-2.79z","fill":"#fff","stroke":"#616161","stroke-width":"2.2","stroke-linecap":"round"}}),_c('path',{attrs:{"d":"M1.6 60.319v0a4.508 4.508 0 015.168-3.958l30.977 4.778a4.63 4.63 0 013.826 5.525v0M13.525 8.311l37.34 3.771","stroke":"#616161","stroke-width":"2.2","stroke-linecap":"round"}}),_c('path',{attrs:{"d":"M20.686 62.17c1.107 0 2.024.91 2.024 2.058 0 1.147-.917 2.057-2.024 2.058-1.107 0-2.025-.91-2.025-2.058 0-1.148.918-2.059 2.025-2.059z","stroke":"#616161","stroke-width":"2.2"}}),_c('path',{attrs:{"d":"M29.473 5.863l6.07.535","stroke":"#616161","stroke-width":"2.2","stroke-linecap":"round"}})])
          )
        }
      }
    